import React from 'react'

function FourOFour() {
  return (

    <div>Page Not Found</div>
  )
}

export default FourOFour